module.exports = __webpack_public_path__ + "img/case42.4be0ccde.png";